import { EventEmitter } from "events";

export const newMonitorEventName = "new";
export const newMonitorEvents = new EventEmitter();
